import { render, staticRenderFns } from "./HeaderDisplay.vue?vue&type=template&id=17cff709"
import script from "./HeaderDisplay.vue?vue&type=script&lang=js"
export * from "./HeaderDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports